<h3>Upload Leads</h3>
<div id="upload_leads">
  <ng-container *ngIf="!failFlag; then noError; else isError"></ng-container>
</div>

<ng-template #noError>
  <ng-container *ngIf="!isUploading; then isUpload; else isSpinner"></ng-container>
</ng-template>

<ng-template #isError>
  <h2>Error uploading file!</h2>
  <span class="hubid">Please contact support</span>
</ng-template>

<ng-template #isUpload>
  <div class="editrow">
    <label for="dispatched" class="left">Upload File: </label>
    <br />
    <input type="file" file-reader="fileContent" (change)="onFileSelected($event)" required accept=".csv">
  </div>
  <br />
  <br />
  <div class="panel">
    <button mat-raised-button color="primary" id="leads_upload" (click)="upload()"
      [disabled]="isDisabled">Upload</button>
  </div>
</ng-template>

<ng-template #isSpinner>
  <div class="uploader-status">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
